export default "__VITE_ASSET__d3f4d4fc__"